import { render, staticRenderFns } from "./payWay.vue?vue&type=template&id=6ca80ab2&scoped=true"
import script from "./payWay.vue?vue&type=script&lang=js"
export * from "./payWay.vue?vue&type=script&lang=js"
import style0 from "./payWay.vue?vue&type=style&index=0&id=6ca80ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca80ab2",
  null
  
)

export default component.exports